import { Component } from '@angular/core';

@Component({
  selector: 'kh-empty-layout',
  styleUrls: ['./empty-layout.component.less'],
  templateUrl: './empty-layout.component.html',
  standalone: false
})
export class EmptyLayoutComponent {

}
